import { $cms } from "@/utils/api";

export function getFeedbacks(params) {
    return $cms().get("/manage/feedback", {
        params,
    });
}

// 获取我的反馈统计
export function getMyFeedbackStat() {
    return $cms().get("/manage/support/stat");
}

// 获取支持中心统计
export function getSupportStat() {
    return $cms().get("/manage/support/count");
}

// 获取我的反馈（管理）
export function getMyFeedbacks(params) {
    return $cms().get("/manage/feedback/i", {
        params,
    });
}

export function getFeedbackLogs(params) {
    return $cms().get(`/manage/feedback/log`, { params });
}

export function getFeedback(id) {
    return $cms().get(`/manage/feedback/${id}`);
}

export function updateFeedback(id, data) {
    return $cms().put(`/manage/feedback/${id}`, data);
}

export function closeFeedback(id, data) {
    return $cms().put(`/manage/feedback/${id}/close`, data);
}
// 转交
export function transferFeedback(id, data) {
    return $cms().put(`/manage/feedback/${id}/transfer`, data);
}
// 开始处理
export function startFeedback(id, data) {
    return $cms().put(`/manage/feedback/${id}/start`, data);
}
// 指派
export function assignFeedback(id, data) {
    return $cms().put(`/manage/feedback/${id}/assign`, data);
}
// 协同
export function coordinatorFeedback(id, data) {
    return $cms().put(`/manage/feedback/${id}/coordinator`, data);
}
// 完成
export function doneFeedback(id, data) {
    return $cms().put(`/manage/feedback/${id}/done`, data);
}
// 重新打开
export function reopenFeedback(id, data) {
    return $cms().put(`/manage/feedback/${id}/reopen`, data);
}

// 补充
export function reply(data) {
    return $cms().post(`/manage/feedback/reply`, data);
}
export function getReplies(params) {
    return $cms().get(`/manage/feedback/reply`, { params });
}
export function deleteReply(id) {
    return $cms().delete(`/manage/feedback/reply/${id}`);
}
export function updateReply(id, data) {
    return $cms().put(`/manage/feedback/reply/${id}`, data);
}
export function changeReplyStatus(id, data) {
    return $cms().put(`/manage/feedback/reply/${id}/status`, data);
}
